<template>
  <div v-if="!isCarousel" :class="$style['c-grid-card-section-mobile__stack']">
    <GridCardSectionCard
      v-for="(card, index) in cards"
      :key="card.id || `mobile-card-${index}`"
      :card="card"
    />
  </div>

  <div v-else :class="$style['c-grid-card-section-mobile__carousel']">
    <Swiper
      :modules="modules"
      :slides-per-view="mobileCardsPerPage"
      :space-between="8"
      :navigation="navigation"
      :pagination="pagination"
      @slideChange="onSlideChange"
    >
      <SwiperSlide v-for="(card, index) in cards" :key="card.id || `mobile-slide-${index}`">
        <div
          :class="[
            $style['c-grid-card-section-mobile__slide'],
            isActiveVisible(index) ? $style['is-active'] : $style['is-inactive'],
          ]"
        >
          <GridCardSectionCard :card="card" />
        </div>
      </SwiperSlide>
    </Swiper>

    <CarouselPageNav
      :show="showNav"
      :prev-class="`gcs-mobile-prev-${instanceKey}`"
      :next-class="`gcs-mobile-next-${instanceKey}`"
      :pagination-class="`gcs-mobile-pagination-${instanceKey}`"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import CarouselPageNav from '@/sections/CarouselPageNav.vue';
import GridCardSectionCard from './GridCardSectionCard.vue';

const props = defineProps<{
  cards: any[];
  isCarousel: boolean;
  mobileCardsPerPage: number;
  instanceKey: string;
}>();

const modules = [Navigation, Pagination];
const activeIndex = ref(0);

const navigation = computed(() => ({
  prevEl: `.gcs-mobile-prev-${props.instanceKey}`,
  nextEl: `.gcs-mobile-next-${props.instanceKey}`,
}));

const pagination = computed(() => ({
  el: `.gcs-mobile-pagination-${props.instanceKey}`,
  clickable: true,
  bulletClass: 'gcs-swiper-dot',
  bulletActiveClass: 'is-active',
}));

const showNav = computed(() => props.cards.length > props.mobileCardsPerPage);

const onSlideChange = (swiper: any) => {
  activeIndex.value = swiper?.activeIndex || 0;
};

const isActiveVisible = (idx: number) =>
  idx >= activeIndex.value && idx < activeIndex.value + props.mobileCardsPerPage;
</script>

<style module lang="scss">
.c-grid-card-section-mobile__stack {
  display: grid;
  gap: 8px;
}

.c-grid-card-section-mobile__slide {
  transition:
    transform 360ms cubic-bezier(0.22, 1, 0.36, 1),
    opacity 300ms ease;
}

.c-grid-card-section-mobile__slide.is-active {
  opacity: 1;
  transform: translateY(0) scale(1);
}

.c-grid-card-section-mobile__slide.is-inactive {
  opacity: 0.76;
  transform: translateY(8px) scale(0.98);
}

@media (min-width: 769px) {
  .c-grid-card-section-mobile__stack,
  .c-grid-card-section-mobile__carousel {
    display: none;
  }
}
</style>
